import React from 'react';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';
import fromAnyToString from 'utils/converters/fromAnyToString';

import CN from './VoucherViewDropdown.module.scss';

const DropdownOptions = ({ calendarMode, onClick, onSelect, options, showButton }) => {
  const { t } = useTranslation();

  const isDark = calendarMode === 'dark';

  const componentClasses = cn({
    [CN.dropdownOption]: true,
    [CN.dropdownOptionDark]: isDark,
  });

  const itemClasses = cn({
    [CN.item]: true,
    [CN.itemDark]: isDark,
  });

  const buttonClasses = cn({
    [CN.button]: true,
    [CN.buttonDark]: isDark,
  });

  return (
    <div data-bem="DropdownOptions" className={componentClasses}>
      {options.map((item) => (
        <div data-bem="DropdownOptions__item" className={itemClasses} key={item.id} onClick={() => onSelect(item)} role="menuitem" tabIndex="0">
          <span>{item.value}</span>
        </div>
      ))}
      {showButton && (
        <div data-bem="DropdownOptions__button" className={buttonClasses} role="button" tabIndex="0" onClick={onClick}>
          {t('scheduler.voucherView.addNewClient')}
        </div>
      )}
    </div>
  );
};

const DropdownInput = ({ onChange, placeholder, value }) => (
  <div data-bem="DropdownInput">
    <input type="text" className={CN.input} placeholder={fromAnyToString(placeholder)} value={fromAnyToString(value)} onChange={onChange} autoComplete="off" />
  </div>
);

const VoucherViewDropdown = ({ children, onBlur }) => (
  <div tabIndex={-1} onBlur={onBlur} className={CN.dropdown}>
    {children}
  </div>
);

Object.assign(VoucherViewDropdown, { Options: DropdownOptions, Input: DropdownInput });

export default VoucherViewDropdown;
